import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["inquiryType", "businessNameField", "businessNameInput"]

  connect() {
    this.setupFormValidation()
    this.setupBusinessNameToggle()
    this.toggleBusinessNameField() // Initial check
  }

  setupFormValidation() {
    const forms = this.element.querySelectorAll('.needs-validation')
    forms.forEach(form => {
      form.addEventListener('submit', this.handleSubmit.bind(this))
    })
  }

  setupBusinessNameToggle() {
    this.inquiryTypeTarget.addEventListener('change', this.toggleBusinessNameField.bind(this))
  }

  handleSubmit(event) {
    if (event.target.checkValidity() === false) {
      event.preventDefault()
      event.stopPropagation()
    }
    event.target.classList.add('was-validated')
  }

  toggleBusinessNameField() {
    const selectedValue = this.inquiryTypeTarget.value
    const businessId = this.element.dataset.businessId
    
    // Show field for new listings or update listings without existing business
    const shouldShow = selectedValue === 'new_listing' || 
                      (selectedValue === 'update_listing' && !businessId)
    
    if (shouldShow) {
      this.businessNameFieldTarget.style.display = 'block'
      this.businessNameInputTarget.required = true
    } else {
      this.businessNameFieldTarget.style.display = 'none'
      this.businessNameInputTarget.required = false
      this.businessNameInputTarget.value = ''
    }
  }
}
